export default {
    isEmpty: (state) => !state.items.length,
    idEdited: (state) => state.bot.idToEdit
}
  